import React from "react";
import {Card, CardActions, CardContent,  CardMedia, Button, Typography} from '@material-ui/core';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import DeleteIcon from '@material-ui/icons/Delete';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import moment from 'moment'
import { useDispatch } from "react-redux";
import { deletePost ,likePost} from "../../../actions/posts";

import useStyles from './styles'

const Post = ({post, setCurrentId})=>{
    const classes = useStyles();
    const dispatch = useDispatch();


    return(
        <Card className={classes.card}>
            <CardMedia className={classes.media} title={post.title} image={post.selectedFile || 'https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png'}/>
            <div className={classes.overlay}>
                <Typography variant="h6">{post.creator}</Typography>
                <Typography variant="body2"> {moment(post.createdAt).fromNow()}</Typography>
            </div>

            {/* edit button on each post */}
            <div className={classes.overlay2}>  
                <Button style={{color: 'white'}} size='small' 
                    onClick={()=>{
                        console.log(post._id)
                        setCurrentId(post._id)
                    }}
                >
                    <MoreHorizIcon fontSize='medium' />
                </Button>
            </div>
            <div className={classes.details}>  
                <Typography variant="body2" color="textSecondary" component="h2">
                    {post.tags.map((tag) => `#${tag} `)}
                </Typography>
            </div>
            <Typography className={classes.title} gutterBottom variant="h5" component="h2">{post.title}</Typography>
            <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">
                    {post.message}
                </Typography>
            </CardContent>
            <CardActions className={classes.cardActions}>
                <Button size="small" color="primary" onClick={()=> {
                    dispatch(likePost(post._id))
                }}>
                    <ThumbUpAltIcon fontSize="small"/>
                    &nbsp; {post.likeCount}
                </Button>
                <Button size="small" color="primary" onClick={()=>{
                    // setCurrentId(post._id) // this is necessary for the post to be deleted
                    // without reloading the page ( check App.js useEffect())
                    dispatch(deletePost(post._id))
                }} >
                    <DeleteIcon fontSize="small" />
                    Delete
                </Button>
            </CardActions>
        </Card>
    )
}

export default Post